/**
 * Storage key constants for localStorage and sessionStorage.
 * These keys are used across AuthModule and BrowserModule for managing
 * authentication state and persisted data.
 */

// localStorage keys
export const STORAGE_KEY_SERVICE_ID = 'serviceId';
export const STORAGE_KEY_SERVICE_NAME = 'serviceName';
export const STORAGE_KEY_REFRESHED_AT = 'refreshedAt';
export const STORAGE_KEY_TASKS = 'tasks';

// sessionStorage keys
export const STORAGE_KEY_AUTH_RESPONSE = 'auth_response';
export const STORAGE_KEY_AUTH_REDIRECT_URL = 'auth_redirect_url';

// localStorage keys for BFF session auth-path selection
/** Stable anonymous browser key used for pre-auth LD context — generated once, survives reload. */
export const STORAGE_KEY_BFF_ANON_ID = 'bff_anon_id';
/** Sticky auth-path assignment persisted after first LD evaluation: 'pkce' | 'session'. */
export const STORAGE_KEY_BFF_AUTH_PATH = 'bff_auth_path';

// localStorage key prefix (used by @openid/appauth library)
export const STORAGE_PREFIX_APPAUTH = 'appauth_';
